import { getLoginState } from 'model/user';
import repo from 'service/repository';
import { REFUELING_REQUEST, SHOW_TOAST_MESSAGE, SET_SCAN_COUNTDOWN, SET_SCAN_RESULT } from 'use-app';
import mqtt from 'service/mqtt';

export const connectMQTT = ({ state, dispatch }) => {
  const checkLatestRefuelingRequest = () => {
    if (getLoginState() === 'user') {
      repo
        .fetchRefuelingRequestsLatest()
        .then(value => {
          if (state.refuelingRequest === null && !state.isRefuelingRequestProcessing && value) {
            dispatch({
              type: REFUELING_REQUEST,
              payload: value,
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  };
  checkLatestRefuelingRequest();
  mqtt.connect();
  mqtt.onActionCallBack = mqttAction => {
    console.log(mqttAction);

    if (mqttAction.type === 'payment_token') {
      switch (mqttAction.action) {
        case 'receive':
          dispatch({ type: SET_SCAN_COUNTDOWN, payload: true });
          break;
        case 'complete':
          dispatch({ type: SET_SCAN_COUNTDOWN, payload: false });
          dispatch({ type: SET_SCAN_RESULT, payload: mqttAction.options });
          break;
        default:
          return;
      }
    }

    switch (mqttAction.action) {
      case 'create':
        checkLatestRefuelingRequest();
        break;
      case 'cancel':
        dispatch({
          type: REFUELING_REQUEST,
          payload: undefined,
        });
        dispatch({
          type: SHOW_TOAST_MESSAGE,
          payload: '此交易授權已由店家取消',
        });
        break;
      default:
        return '';
    }
  };
};
